import { useQuery } from "@apollo/client";
import { clientNeoAuth } from "@neonumy/api-clients";
import { LIST_WORKSHIFT_CHOICES } from "queries/neoauth/users";
import { useEffect } from "react";
import { onErrorGraphql } from "utils/onErrorGraphql";

export default function useCollabsApi() {
  const { data, error } = useQuery<ListWorkShiftChoicesOutput>(LIST_WORKSHIFT_CHOICES, {
    client: clientNeoAuth,
    fetchPolicy: "cache-first",
  });

  useEffect(() => {
    if (error) onErrorGraphql(error);
  }, [error]);

  const workShiftChoices: Option[] =
    data?.listWorkShiftChoices.map(item => ({
      label: item.label,
      value: item.value,
    })) || [];

  return {
    workShiftChoices,
  };
}
